import { getSlider } from 'simple-slider';

const galleries = document.getElementsByClassName('js-gallery-slider');

function expoInOut(time, begin, change, duration) {
  let t = time;

  if (t === 0) {
    return begin;
  }
  if (t === duration) {
    return begin + change;
  }

  t /= duration / 2;

  if (t < 1) {
    // eslint-disable-next-line no-restricted-properties
    return (change / 2) * Math.pow(2, 10 * (t - 1)) + begin;
  }
  // eslint-disable-next-line no-restricted-properties
  return (change / 2) * (-Math.pow(2, -10 * (t - 1)) + 2) + begin;
}

function initGallerySlider() {
  for (let forIndex = 0; forIndex < galleries.length; forIndex += 1) {
    if (galleries[forIndex].classList.contains('js-gallery--vert-down')) {
      getSlider({
        container: galleries[forIndex],
        duration: 1.25,
        delay: 2.5,
        prop: 'top',
        ease: expoInOut,
      });
    } else if (galleries[forIndex].classList.contains('js-gallery--vert-up')) {
      getSlider({
        container: galleries[forIndex],
        duration: 1.25,
        delay: 2.5,
        prop: 'top',
        init: 100,
        end: -100,
        ease: expoInOut,
      });
    } else {
      getSlider({
        container: galleries[forIndex],
        prop: 'opacity',
        duration: 1,
        unit: '',
        init: 0,
        show: 1,
        end: 0,
      });
    }
  }
}

export default initGallerySlider;



// WEBPACK FOOTER //
// ./src/scripts/modules/gallery-slider.js